export const sentences = [
  'They discovered it by accident.',
  'Diagnosed at the age of seven.',
  'Not fast enough.',
  'Stutter when reading aloud',
  'Reading everything the same way.',
  'It’s kinda like a muscle.',
  'Nobody really knew it existed.',
  'Professionally is difficult.',
  'Balance is key.',
  'Equally bad in my case.',
  'Slower than the average person.',
  'It happens in a millisecond.',
  'Anything too bold or thick.',
  'It goes with more ease.',
  'Broadly speaking it isn’t too bad.',
  'It’s a chain reaction really',
  'Everybody makes mistakes.',
  'Rediscover how to write words.',
  'It got more easy over time.',
  'The term didn’t exist back then.',
  'Improvement isn’t noticeably.',
  'Check for spelling mistakes.',
  'My mind wanders off quickly.',
  'There’s a big difference.',
  'It’s much easier this way.',
  'Exchange letters in a word.',
  'Jump from one side to another.',
  'It’s really embarrassing.',
  'Learning to live with it.',
  'Luckily I’ve a feel for tongue.',
  'He dropped out of high school.',
  'Learning to manage it.',
  'This changed my life forever.',
  'Learning to play around it.',
  'Accentuated when reading.',
  'Issues with reading diphthongs.',
  'Changing and rotate easily.',
  'Varies from time to time.',
  'A slight inconvenience.',
  'A combination of several.',
  'The only adult in the waiting room.',
  'The phenomenon was not known.',
  'Trying to make myself smarter.',
  'Creating tricks to perform better.',
  'Lose sight of things.',
  'It hinders punctuality.',
  'It shows a three-dimensional effect.',
  'Not ashamed of having dyslexia.',
  'Without a doubt.',
  'A slow reader.',
  'Problems are generally based.',
  'Luckily for autocorrect.',
  'Luckily for spelling checkers.',
  'The symptoms occur in both.',
  'Re-read and adjust.',
  'Too many mistakes.',
  'As little as possible.',
  'Reading in front of people.',
  'Reading longer sentences.',
  'Can be frustrating at times.',
  'It can be confronting as well.',
  'Words stick together.',
  'Continually making mistakes.',
  'Making mistakes without hearing.',
  'Challenging myself regularly.',
  'Some contradictions are true.',
  'Struggle with reading abilities.',
  'It’s a personal preference.',
  'Maintaining reading skills.',
  'Requires much concentration.',
  'Uncertainty will remain forever.',
  'Everyone else starts laughing.',
  'Mistakes aren’t a big deal.',
  'Reading it incorrectly.',
  'Guessing wrongly.',
  'Recreating the content in a way.',
  'Recognize structures in general.',
  'Kind of typeface has an influence.',
  'It’s not really an issue.',
  'Lines become one block of text.',
  'All the same or quite similar.',
  'Difficult to manage everything.',
  'Adapting into using technology.',
  'Reading things fluently.',
  'Fifty-fifty chance it’s wrong.',
  'Failing really bad.',
  'Learning by heart.',
  'Using glasses as they relax.',
  'Going over a word several times.',
  'Quickly doubting everything.',
  'Managing with perseverance.',
  'Losing the sequence.',
  'Reading things double.',
  'Keeping myself calm.',
  'Light or very bold typefaces.',
  'Close or very wide lining.',
  'Tight or very large spacing.',
  'Hurting my eyes and tires me.',
  'Instantly forgetting what I just saw.',
  'Confuse shape or sound regularly.',
  'Trouble with heavy left confusions.',
  'It can get quite complicated.',
  'Bad typesetting can be dreadful.',
  'From my point of view.',
  'Pressured and stressed.',
  'It gets easier with training.',
  'Afraid to ask for help.',
  'Reading for pleasure.',
  'Switched and swapped letters.',
  'Things in between are quite blurry.',
  'Think twice or get it checked.',
  'Nothing too thin or too bold.',
  'Knowledge is key.',
  'A combination of the two.',
  'It runs in the family.',
  'Focussing on reading out loud.',
  'Learn to live with the disorder.',
  'Practical and convenient.',
  'It became immediately easier.',
  'It can take up to ten seconds before realizing what’s actually wrong.',
  'It’s too hard to recognize the shapes from one another.',
  'Running behind in reading class, and couldn’t get past a certain reading level.',
  'As a reward they would read me one or two in return.',
  'My brain can’t handle processing tons of information for long periods of time.',
  'It’s something I have rather than something that I am.',
  'The two go hand in hand as the one stimulates the other and vice versa.',
  'Struggling with certain language rules in my mother tongue.',
  'Always thinking twice about it before writing anything down.',
  'It mostly affects my self-confidence and that of course leads to bigger problems.',
  'Reading out loud in front of people scares me a lot.',
  'Proofreading everything can take a long time and be tedious for me.',
  'There has been some significant improvement since my diagnosis.',
  'My brain cannot distinguish long words from each other for some odd reason.',
  'It’s apparently a known phenomenon that it always skips a generation.',
  'A lot of mistakes and start pronouncing words incorrectly.',
  'Having the tendency to write everything down in a phonetical way.',
  'It has been proven that we can solve visual situations better.',
  'It has its advantages in the artistic or scientific disciplines.',
  'Many teachers were quite skeptical about everything and didn’t want to help.',
  'It can be quite frustrating at times and slows down the process.',
  'Whenever it’s too small it’s difficulties to recognize the shapes.',
  'It definitely helpt in understanding my position in the world.',
  'That being someone to whom reading and writing didn’t come easy to.',
  'Normally when you build a skill there is a natural progression.',
  'This was never the case with reading or at least it seemed that way.',
  'Reading it twice in order to see what is actually there.',
  'The biggest problem lies with writing and not necessarily with reading.',
  'An ability that gives me a better understanding of reading and writing.',
  'After a while it resulted in a low self-esteem and a lack of confidence.',
  'To be confronted with my own incompetence and stupidity.',
  'They place rhythm in their writing and they engage you.',
  'Leave enough white space between paragraphs so your eyes don’t go crazy.',
  'Keep the sentences short and don’t use words that haven’t been spoken aloud for centuries.',
  'It’s not just a lack of reading but an entire different way of processing something.',
  'I believe that our brain sees everything as a whole, as a dynamic or a rhythm.',
  'Whilst looking at specific and individual shapes, things get complicated really fast.',
  'It gives me the impression that the letters are slightly stretched out.',
  'Taking a book spontaneously is not something I do on a regular basis.',
  'Having trouble with aligning a strong baseline.',
  'You learn some tricks along the way and you manage to control it.',
  'I’ll pack up quickly, re-read the sentence and then it goes smooth.',
  'I’ve managed to control the disability and not the other way around.',
  'As an adult I don’t make the same mistake as I used to do when I was younger.',
  'For over twenty years I’ve been struggling with writing things down.',
  'I’ve been laughed at a lot and was often labeled stupid by teachers.',
  'Speaking in front of others is no major problem but reading is horrible.',
  'If the typeface is simple and quite clear then it’s easier to read it fluently.',
  'When there are too many curls or it looks unbalanced it’s hard to recognize the shapes.',
  'Reading on my own, with no stress and at my own pace.',
  'The content or meaning of a text changes.',
  'Lacking a good insight on how thing are constructed and recreate a new one entirely.',
  'No longer see the beginning and ending of a word.',
  'My brain skips or ignores pieces which makes the entire content unreadable.',
  'Having something in your hands is much more stable to me.',
  'Feeling very uncomfortable with speaking or reading in another language.',
  'You feel that it’s not going smooth and notice that others notice it too.',
  'Using it as a motivation and work harder than usual.',
  'Carrying out my profession with great passion',
  'There will always remain an eternal struggle.',
  'Working with children that had some difficulties with reading, writing and spelling.',
  'A combination of certain words turn into a similar one that would fit into the context.',
  'Not able to concentrate when driving as too much is happening on the left and right.',
  'You learn to live with it and over time you develop strategies that help.',
  'Concentration is often hard to find and I just can’t find the time for it.',
  'My mind can’t keep up and loses track of how all those words are set up.',
  'After a while it had improved to a level that was acceptable.',
  'Learning various characters by heart.',
  'This took away the pleasure of reading and changed the way I cope with languages.',
  'With a correct diagnosis a weight felt off my shoulders.',
  'Finding a letter in the alphabet still remains a mystery.',
  'We were always surrounded us with books and were encouraged to read.',
  'Reading became a pleasure and wasn’t an obligation.',
  'When driving on the highway I get confused reading the signs.',
  'A book is worse when the printing consists of bad quality.',
  'If you train and become better in one skill, you lose performance in something else.',
  'The correct pronunciation of accents is difficult.',
  'If you pronounce a word wrongly, it’s hard to read it out loud.',
  'Performing in an emergency situation paralyzes me sort to speak.',
  'A frequent boredom and loneliness that makes me question certain things.',
  'Things have changed and evolved in a good way and it continues to do so.',
];
